const IP = process.env.NODE_ENV === 'production' ? 'https://api.snbc-connect.com/api' : 'https://oms-api.searchopal.ca/api';

// const IP = "snb-nomu-be.onrender.com"


export default IP;